import React from 'react';
import { Hero } from '../components/Hero';
import { Welcome } from '../components/Welcome';
import { MarketContext } from '../components/MarketContext';
import { LaunchCTA } from '../components/LaunchCTA';
import { Vision } from '../components/Vision';
import { SectionsPreview } from '../components/SectionsPreview';
import { DomainCTA } from '../components/DomainCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-zinc-950 text-zinc-100 font-sans selection:bg-magenta-500/30 selection:text-magenta-100" data-id="element-131">
      <main data-id="element-132">
        <Hero data-id="element-133" />
        <Welcome data-id="element-134" />
        <MarketContext data-id="element-135" />
        <LaunchCTA data-id="element-136" />
        <Vision data-id="element-137" />
        <SectionsPreview data-id="element-138" />
        <DomainCTA data-id="element-139" />
      </main>
      <Footer data-id="element-140" />
    </div>;
}